module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.modalTitle,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [(_vm.mode === 'review') ? [_c('div', {
    staticClass: "review-field"
  }, [_c('div', {
    staticClass: "review-label"
  }, [_vm._v("审核结果")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.decision),
      callback: function($$v) {
        _vm.decision = $$v
      },
      expression: "decision"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "pass"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "fail"
    }
  }, [_vm._v("不通过")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "review-field"
  }, [_c('div', {
    staticClass: "review-label"
  }, [_vm._v("定级")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  }, _vm._l((_vm.grades), function(g) {
    return _c('Option', {
      key: g,
      attrs: {
        "value": g
      }
    }, [_vm._v(_vm._s(g))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "review-field"
  }, [_c('div', {
    staticClass: "review-label"
  }, [_vm._v("意见")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "maxlength": 500,
      "placeholder": "填写复审意见…"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)] : [_c('div', {
    staticClass: "result-row"
  }, [_c('span', {
    staticClass: "result-label"
  }, [_vm._v("状态")]), _vm._v(" "), _c('span', {
    staticClass: "result-value"
  }, [_vm._v(_vm._s(_vm.statusText))])]), _vm._v(" "), _c('div', {
    staticClass: "result-row"
  }, [_c('span', {
    staticClass: "result-label"
  }, [_vm._v("审核")]), _vm._v(" "), _c('span', {
    staticClass: "result-value"
  }, [_vm._v(_vm._s(_vm.decisionText))])]), _vm._v(" "), _c('div', {
    staticClass: "result-row"
  }, [_c('span', {
    staticClass: "result-label"
  }, [_vm._v("定级")]), _vm._v(" "), _c('span', {
    staticClass: "result-value"
  }, [_vm._v(_vm._s((_vm.row && _vm.row.reviewGrade) || '—'))])]), _vm._v(" "), _c('div', {
    staticClass: "result-block"
  }, [_c('div', {
    staticClass: "result-label"
  }, [_vm._v("意见")]), _vm._v(" "), _c('div', {
    staticClass: "result-remark"
  }, [_vm._v(_vm._s((_vm.row && _vm.row.reviewRemark) || '（无）'))])]), _vm._v(" "), _c('div', {
    staticClass: "result-meta"
  }, [_vm._v(_vm._s((_vm.row && _vm.row.reviewerName) || '') + " · " + _vm._s((_vm.row && _vm.row.reviewTime) || ''))])], _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.mode === 'review') ? [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交复审结果")])] : _c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6934697a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/modal/RecruitReviewModal.vue
// module id = 1867
// module chunks = 8